// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── trigger button ─────────────────────────────────────── */
.ccs-root {
  position: relative;
  flex-shrink: 0;
}

.ccs-trigger {
  display: flex;
  align-items: center;
  gap: 5px;
  background: #f8fafc;
  border: none;
  border-right: 1px solid #e2e8f0;
  padding: 0 10px 0 14px;
  cursor: pointer;
  border-radius: 24px 0 0 24px;
  font-size: 14px;
  font-weight: 700;
  color: #334155;
  transition: background 0.15s;
  white-space: nowrap;
  align-self: stretch;
  height: 100%;
}

.ccs-trigger:hover,
.ccs-trigger.open {
  background: #eff6ff;
  color: #2a71ff;
}

.ccs-flag {
  font-size: 1.15rem;
  line-height: 1;
}

.ccs-dial {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.2px;
}

.ccs-chevron {
  color: #94a3b8;
  transition: transform 0.2s;
  flex-shrink: 0;
}

.ccs-chevron.rotated {
  transform: rotate(180deg);
}

/* ── dropdown panel ─────────────────────────────────────── */
.ccs-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  left: -16px;
  width: 280px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.12);
  z-index: 1000;
  overflow: hidden;
}

/* ── search ─────────────────────────────────────────────── */
.ccs-search-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
}

.ccs-search-icon {
  flex-shrink: 0;
}

.ccs-search {
  flex: 1;
  border: none;
  outline: none;
  font-size: 13px;
  color: #334155;
  background: transparent;
  min-width: 0;
}

.ccs-search::placeholder {
  color: #94a3b8;
}

/* ── list ───────────────────────────────────────────────── */
.ccs-list {
  max-height: 220px;
  overflow-y: auto;
  padding: 4px 0;
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}

.ccs-list::-webkit-scrollbar {
  width: 4px;
}

.ccs-list::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 4px;
}

.ccs-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  gap: 10px;
  transition: background 0.1s;
}

.ccs-item:hover {
  background: #f8fafc;
}

.ccs-item.selected {
  background: #eff6ff;
}

.ccs-item-flag {
  font-size: 1.2rem;
  flex-shrink: 0;
  width: 24px;
  text-align: center;
}

.ccs-item-name {
  flex: 1;
  font-size: 13px;
  color: #334155;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ccs-item.selected .ccs-item-name {
  color: #2a71ff;
  font-weight: 600;
}

.ccs-item-dial {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 600;
  flex-shrink: 0;
}

.ccs-item.selected .ccs-item-dial {
  color: #2a71ff;
}

.ccs-empty {
  padding: 16px 12px;
  font-size: 13px;
  color: #94a3b8;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/CountryCodeSelect.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* ── trigger button ─────────────────────────────────────── */\n.ccs-root {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.ccs-trigger {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background: #f8fafc;\n  border: none;\n  border-right: 1px solid #e2e8f0;\n  padding: 0 10px 0 14px;\n  cursor: pointer;\n  border-radius: 24px 0 0 24px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #334155;\n  transition: background 0.15s;\n  white-space: nowrap;\n  align-self: stretch;\n  height: 100%;\n}\n\n.ccs-trigger:hover,\n.ccs-trigger.open {\n  background: #eff6ff;\n  color: #2a71ff;\n}\n\n.ccs-flag {\n  font-size: 1.15rem;\n  line-height: 1;\n}\n\n.ccs-dial {\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n}\n\n.ccs-chevron {\n  color: #94a3b8;\n  transition: transform 0.2s;\n  flex-shrink: 0;\n}\n\n.ccs-chevron.rotated {\n  transform: rotate(180deg);\n}\n\n/* ── dropdown panel ─────────────────────────────────────── */\n.ccs-dropdown {\n  position: absolute;\n  top: calc(100% + 10px);\n  left: -16px;\n  width: 280px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.12);\n  z-index: 1000;\n  overflow: hidden;\n}\n\n/* ── search ─────────────────────────────────────────────── */\n.ccs-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.ccs-search-icon {\n  flex-shrink: 0;\n}\n\n.ccs-search {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 13px;\n  color: #334155;\n  background: transparent;\n  min-width: 0;\n}\n\n.ccs-search::placeholder {\n  color: #94a3b8;\n}\n\n/* ── list ───────────────────────────────────────────────── */\n.ccs-list {\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 4px 0;\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 transparent;\n}\n\n.ccs-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.ccs-list::-webkit-scrollbar-thumb {\n  background: #e2e8f0;\n  border-radius: 4px;\n}\n\n.ccs-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  gap: 10px;\n  transition: background 0.1s;\n}\n\n.ccs-item:hover {\n  background: #f8fafc;\n}\n\n.ccs-item.selected {\n  background: #eff6ff;\n}\n\n.ccs-item-flag {\n  font-size: 1.2rem;\n  flex-shrink: 0;\n  width: 24px;\n  text-align: center;\n}\n\n.ccs-item-name {\n  flex: 1;\n  font-size: 13px;\n  color: #334155;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ccs-item.selected .ccs-item-name {\n  color: #2a71ff;\n  font-weight: 600;\n}\n\n.ccs-item-dial {\n  font-size: 12px;\n  color: #94a3b8;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.ccs-item.selected .ccs-item-dial {\n  color: #2a71ff;\n}\n\n.ccs-empty {\n  padding: 16px 12px;\n  font-size: 13px;\n  color: #94a3b8;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
